import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'mwe-transparent-card',
  templateUrl: './transparent-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransparentCardComponent {
}
